import {
  NotificationReport,
  ChartData,
  TopVisitData,
  TopMenuData,
  Export,
} from '@/domain/entities/NotificationReports'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class NotificationReportDataMapper extends BaseResponseMapper {
  public convertNotificationReportFromApi(
    result: AxiosResponse<any>
  ): NotificationReport {
    const { data } = result
    return new NotificationReport(
      data.success,
      data.message,
      data.data.top_menu.items.map(
        (menu) =>
          new TopMenuData(menu.id, menu.name, menu.key, menu.value, menu.color)
      ),
      data.data.charts.items.map(
        (chart) => new ChartData(chart.period, chart.total)
      ),
      data.data.top_visit.items.map(
        (user) =>
          new TopVisitData(
            user.id,
            user.title,
            user.file_type,
            user.created_date,
            user.total_assignment,
            user.total_user_access,
            user.total_visit
          )
      )
    )
  }
  public convertExportFileFromAPi(result: AxiosResponse<any>): Export {
    const { data } = result
    return new Export(data.success, data.message, data.data)
  }
}
